import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51ff0d82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = { class: "text-truncate" }
const _hoisted_4 = { class: "text-truncate" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZSideDrawer = _resolveComponent("VZSideDrawer")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_ActivityModal = _resolveComponent("ActivityModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      bulkDelete: _ctx.bulkDelete,
      tableForm: _ctx.formData,
      defaultFilter: _ctx.defaultFilter,
      tableFilter: _ctx.tableFilter,
      activityTab: false,
      addButtonText: `${_ctx.t('pages.location.addLocation')}`,
      viewName: "locations",
      onQueryUpdate: _ctx.queryUpdate,
      onTableRowClick: _ctx.tableRowClick,
      onBulkDelete: _ctx.onBulkDelete,
      onFormSubmit: _ctx.submit,
      permissions: _ctx.permissionModel,
      ref: "datatable"
    }, {
      "cell-name": _withCtx(({ row: location }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(location.name), 1)
      ]),
      "cell-startDate": _withCtx(({ row: location }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.format.convertUTCToLocalDate(location.startDate)), 1)
      ]),
      "cell-endDate": _withCtx(({ row: location }) => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.format.convertUTCToLocalDate(location.endDate)), 1)
      ]),
      "cell-createdBy": _withCtx(({ row: location }) => [
        _createElementVNode("span", _hoisted_4, _toDisplayString(location.createdBy), 1)
      ]),
      "cell-status": _withCtx(({ row: lookup }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success': lookup.status?.toLowerCase() === 'active',
          'badge badge-danger': lookup.status?.toLowerCase() !== 'active',
        }])
        }, _toDisplayString(_ctx.format.TitleCase(lookup.status?.toLowerCase())), 3)
      ]),
      "cell-actions": _withCtx(({ row: lookup }) => [
        (_ctx.hasPermission(_ctx.permissionModel.update))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _withModifiers(($event: any) => (_ctx.editLocation(lookup)), ["stop"]),
              "data-bs-toggle": "modal",
              "data-bs-target": "#vz-add-edit-modal-locations",
              class: "btn btn-icon btn-primary btn-circle btn-sm"
            }, _hoisted_7, 8, _hoisted_5))
          : _createCommentVNode("", true),
        (!lookup.lock && _ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForAction = lookup;
          }
        , ["stop"]),
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
            }, _hoisted_10, 8, _hoisted_8))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "bulkDelete", "tableForm", "defaultFilter", "tableFilter", "addButtonText", "onQueryUpdate", "onTableRowClick", "onBulkDelete", "onFormSubmit", "permissions"]),
    _createVNode(_component_VZSideDrawer, {
      modelValue: _ctx.openDrawer,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.openDrawer) = $event)),
      title: _ctx.sideDrawerTitle,
      icon: _ctx.sideDrawerIcon,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDrawer = false)),
      tabs: _ctx.tabs
    }, null, 8, ["modelValue", "title", "icon", "tabs"]),
    (_ctx.hasPermission(_ctx.permissionModel.delete))
      ? (_openBlock(), _createBlock(_component_VZDeleteModal, {
          key: 0,
          showDialog: _ctx.showDeleteDialog,
          viewName: "locations",
          onBulkDelete: _ctx.onBulkDelete,
          selectedForAction: [_ctx.selectedForAction.webId],
          deleteText: `${_ctx.t('validation.sureToDelete')} ${_ctx.selectedForAction.name}?`,
          pageName: "location",
          onClose: _ctx.refreshList
        }, null, 8, ["showDialog", "onBulkDelete", "selectedForAction", "deleteText", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ActivityModal, {
      refresh: _ctx.loading,
      icon: "fs-3 bi bi-geo-alt",
      viewName: "Locations Activity Pulse",
      type: "2600,1700,1500"
    }, null, 8, ["refresh"])
  ], 64))
}